import script from "./ViewApplicationDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewApplicationDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ViewApplicationDetails.vue?vue&type=style&index=0&id=3f7d78a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f7d78a6"]])

export default __exports__